'use client';

import { createContext, useContext, useState, ReactNode } from 'react';

type SiteMapContextType = {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
};

const SiteMapContext = createContext<SiteMapContextType | null>(null);

export function useSiteMapContext() {
  const context = useContext(SiteMapContext);
  if (!context) {
    throw new Error('useSiteMapContext must be used within a SiteMapProvider');
  }
  return context;
}

export function SiteMapProvider({ children }: { children: ReactNode }) {
  const [searchQuery, setSearchQuery] = useState('');

  return (
    <SiteMapContext.Provider value={{ searchQuery, setSearchQuery }}>
      {children}
    </SiteMapContext.Provider>
  );
}
